export default import.meta.ROLLDOWN_FILE_URL_7haGRlwED4JkyOuHIL$T3w